module.exports = __webpack_public_path__ + "img/icon_tweed_20.7b9e4cd0.png";